// Base URL proxied by server.mjs: /api/ai → agent-service /api
const AGENT_BASE_URL = import.meta.env.VITE_AGENT_SERVICE_URL ?? "/api/ai";

interface AgentRequestInit {
  body?: unknown;
  signal?: AbortSignal;
}

async function agentFetch(
  path: string,
  init: AgentRequestInit = {},
): Promise<Response> {
  console.log("agentFetch :", `${AGENT_BASE_URL}${path}`);

  const response = await fetch(`${AGENT_BASE_URL}${path}`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: init.body !== undefined ? JSON.stringify(init.body) : undefined,
    signal: init.signal,
  });

  // NOTE: do NOT throw on !response.ok — the caller (useAgentStream) inspects
  // status codes such as 429 to surface dedicated UX (quota_exceeded card).
  return response;
}

async function agentGet(
  path: string,
  init: { signal?: AbortSignal } = {},
): Promise<Response> {
  return fetch(`${AGENT_BASE_URL}${path}`, {
    method: "GET",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    signal: init.signal,
  });
}

export const agentApiClient = {
  post: agentFetch,
  get: agentGet,
};
